<script>
import TransactionList from '../../components/transaction/TransactionList.vue'

export default {
  components: {
    TransactionList
  },
}
</script>


<template>
  <TransactionList
      endpoint="transaction"
  />
</template>
